import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FileText, FolderTree, UserPen, Tags, Plus, Image as ImageIcon } from 'lucide-react';
import { Button } from '../../components/ui/button';
import './AdminBlog.css';

export const blogNavigation = [
  { to: '/admin/blogs', label: 'All posts', icon: FileText },
  { to: '/admin/blog-categories', label: 'Categories', icon: FolderTree },
  { to: '/admin/blog-authors', label: 'Authors', icon: UserPen },
  { to: '/admin/blog-tags', label: 'Tags', icon: Tags },
  { to: '/admin/blog-uploads', label: 'Uploads', icon: ImageIcon },
];

export default function BlogNavTabs({ showCreateButton = true, title = "Blog posts", description = "Manage, create and publish blog content for your website." }) {
  const navigate = useNavigate();

  return (
    <div className="blog-nav-header space-y-4 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <p className="admin-eyebrow">Content Management</p>
          <h1 className="admin-title text-2xl font-bold text-slate-900">{title}</h1>
          {description && <p className="admin-description text-sm text-slate-500 mt-1">{description}</p>}
        </div>

        {showCreateButton && (
          <div className="flex items-center gap-2">
            <Button
              onClick={() => navigate('/admin/blogs/new')}
              className="admin-primary flex items-center gap-2 font-semibold shadow-sm"
            >
              <Plus size={16} />
              <span>Create blog post</span>
            </Button>
          </div>
        )}
      </div>

      {/* Subtabs matching Shopify / WordPress navigation */}
      <nav aria-label="Blog management" className="blog-nav-tabs">
        {blogNavigation.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `blog-nav-tab ${isActive ? 'is-active' : ''}`
            }
          >
            <Icon size={15} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
